import Vue from 'vue';
import ToolBar from "../../parts/ToolBar.vue";
export default Vue.extend({
    components: { ToolBar },
    name: "WalletCreationType",
    data() {
        return {
            items: [
                { image: "heroimage_new_card.png", color: "primary", text: "Create New Wallet", to: "/wallet/creation/name" },
                { image: "heroimage_login_card.png", color: "nemBlue", text: "LOGIN", to: "/wallet/login/import" },
            ]
        };
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletCreationType.vue
// module id = 612
// module chunks = 1